"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _Functions = require("../core/Functions");

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _reactAddonsPureRenderMixin = _interopRequireDefault(require("react-addons-pure-render-mixin"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _UICopyButton = _interopRequireDefault(require("../button/UICopyButton"));

var _UIExpandingTextArea = _interopRequireDefault(require("../input/UIExpandingTextArea"));

var _UITextArea = _interopRequireDefault(require("../input/UITextArea"));

var _ShareInput = _interopRequireDefault(require("../decorators/ShareInput"));

var _refObject = _interopRequireDefault(require("../utils/propTypes/refObject"));

var DefaultButtonRow = function DefaultButtonRow(_ref) {
  var className = _ref.className,
      onClick = _ref.onClick,
      tooltipPlacement = _ref.tooltipPlacement,
      use = _ref.use,
      value = _ref.value;
  return _react.default.createElement("div", {
    className: className
  }, _react.default.createElement(_UICopyButton.default, {
    onClick: onClick,
    tooltipPlacement: tooltipPlacement,
    use: use,
    value: value
  }));
};

var UICopyTextArea = _react.default.createClass({
  displayName: "UICopyTextArea",
  mixins: [_reactAddonsPureRenderMixin.default],
  propTypes: {
    autoSelect: _react.PropTypes.bool.isRequired,
    buttonRowRenderer: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.node]),
    buttonUse: _UICopyButton.default.propTypes.use,
    inputRef: _refObject.default,
    onChange: _react.PropTypes.func,
    onCopy: _react.PropTypes.func,
    textAreaProps: _react.PropTypes.object,
    tooltipPlacement: _UICopyButton.default.propTypes.tooltipPlacement,
    use: _react.PropTypes.oneOf(['default', 'code']),
    value: _react.PropTypes.string
  },
  getDefaultProps: function getDefaultProps() {
    return {
      autoSelect: true,
      buttonRowRenderer: DefaultButtonRow,
      buttonUse: 'tertiary',
      textAreaProps: {},
      tooltipPlacement: 'right',
      use: 'default'
    };
  },
  handleCopyClick: function handleCopyClick(evt) {
    var _this$props = this.props,
        inputRef = _this$props.inputRef,
        onCopy = _this$props.onCopy;
    if (inputRef.current) inputRef.current.select();
    (0, _Functions.callIfPossible)(onCopy, evt);
  },
  handleTextAreaMouseDown: function handleTextAreaMouseDown(evt) {
    var _this$props2 = this.props,
        autoSelect = _this$props2.autoSelect,
        inputRef = _this$props2.inputRef;

    if (autoSelect) {
      evt.preventDefault();
      if (inputRef.current) inputRef.current.select();
    }
  },
  render: function render() {
    var _this$props3 = this.props,
        __autoSelect = _this$props3.autoSelect,
        buttonUse = _this$props3.buttonUse,
        ButtonRowRenderer = _this$props3.buttonRowRenderer,
        inputRef = _this$props3.inputRef,
        onChange = _this$props3.onChange,
        __onCopy = _this$props3.onCopy,
        textAreaProps = _this$props3.textAreaProps,
        tooltipPlacement = _this$props3.tooltipPlacement,
        use = _this$props3.use,
        value = _this$props3.value,
        rest = (0, _objectWithoutProperties2.default)(_this$props3, ["autoSelect", "buttonUse", "buttonRowRenderer", "inputRef", "onChange", "onCopy", "textAreaProps", "tooltipPlacement", "use", "value"]);
    var TextArea = use === 'code' ? _UITextArea.default : _UIExpandingTextArea.default;
    return _react.default.createElement("div", rest, _react.default.createElement(TextArea, (0, _extends2.default)({}, textAreaProps, {
      className: (0, _classNames.default)('private-text-area--copyable', {
        'private-text-area--code is--code': use === 'code'
      }),
      inputRef: inputRef,
      onChange: onChange,
      onMouseDown: this.handleTextAreaMouseDown,
      readOnly: use === 'code' ? true : textAreaProps.readOnly,
      resize: use === 'code' ? false : textAreaProps.resize,
      type: "text",
      value: value
    })), _react.default.createElement(ButtonRowRenderer, {
      className: "m-y-3",
      onClick: this.handleCopyClick,
      tooltipPlacement: tooltipPlacement,
      use: buttonUse,
      value: value
    }));
  }
});

var _default = (0, _ShareInput.default)((0, _Controllable.default)(UICopyTextArea));

exports.default = _default;
module.exports = exports.default;